import React from 'react'
import {
    Card, CardImg, CardText, CardBody, UncontrolledCollapse,
    Button,
    Container
} from 'reactstrap';

import ConsultadorInicio from '../../../../public/img/Help/ConsultadorInicio.png';
import ConsultadorDetalleArticulo from '../../../../public/img/Help/ConsultadorDetalleArticulo.png';

const Consultador = () => {
    return (
        <Container fluid className="rounded contenedor-scrolleable">
            <header>
                <h2 className="text-center">Consultador Web</h2>
            </header>
            <div>
                <Button color="primary" id="ConsultadorInicio" style={{ marginBottom: '1rem' }}>
                ¿Que información ofrece el consultador web?
                </Button>
                <UncontrolledCollapse toggler="#ConsultadorInicio">
                    <Card>
                        <CardImg top width="100%" src={ConsultadorInicio} className="img-fluid" alt="Consultador Web" title="Consultador Web" />
                        <CardBody>
                            <CardText>El Consultador Web centraliza en un solo lugar la información de precios y stock de los artículos.</CardText>
                        </CardBody>
                    </Card>
                </UncontrolledCollapse>
                <br />
                <Button color="primary" id="ConsultadorDetalle" style={{ marginBottom: '1rem' }}>
                ¿Que veo en el detalle de un artículo?
                </Button>
                <UncontrolledCollapse toggler="#ConsultadorDetalle">
                    <Card>
                        <CardImg top src={ConsultadorDetalleArticulo} className="img-modal-content" alt="Consultador Web - Detalle de Artículo" title="Detalle de Artículo" />
                        <CardBody>
                            <CardText>En el detalle de artículo se presenta información como precios según listas de precios y cantidades en stock según deposito.</CardText>
                        </CardBody>
                    </Card>
                </UncontrolledCollapse>
                <br />
            </div>
        </Container>
    )
}
export default Consultador;


// WEBPACK FOOTER //
// ./src/views/Ayuda/Paneles/Consultador.js